import classnames from 'classnames';
import { FunctionComponent } from 'react';
import * as styles from './ConsultationList.css';
import * as T from './ConsultationList.types';
import ScrollSnap from 'Components/ScrollSnap';
import ConsultationListItem from 'Components/ConsultationListItem';
import LazyLoadProvider from '@media-ui/core/src/components/LazyLoadProvider';
export const ConsultationList: FunctionComponent<T.ConsultationListProps> = ({ className, items, classNameScrollItem, classNameConsultationItem, scrollPosition, showPrevArrow = false, showNextArrow = true, isTouch, }) => {
    const classNameProp = classnames(styles.root, className);
    const renderedItems = items.map((data, i) => {
        return (<ConsultationListItem className={classNameConsultationItem} {...data} key={i} isTouch={isTouch}>
        {data.text}
      </ConsultationListItem>);
    });
    return (<LazyLoadProvider>
      <ScrollSnap dataQa="ConsultationList" position={scrollPosition} classNameItem={classNameScrollItem} className={classNameProp} showPrevArrow={showPrevArrow} showNextArrow={showNextArrow}>
        {renderedItems}
      </ScrollSnap>
    </LazyLoadProvider>);
};
